import { useDispatch, useSelector } from 'react-redux';
import '../../../../styles/screens/client-visit-details/manage-module/SpeakersList.css';
import noConcierge from '../../../../assets/no-concierge.svg';
import Loader from '../../../common-components/Loader';
import { useEffect, useState } from 'react';
import { ConciergeStringLabels } from '../../../../util/Strings';
import ErrorAlert from '../../../common-components/ErrorAlert';
import ErrorMessages from '../../../../util/ErrorMessages';
import ConciergeCard from '../ConciergeCard';
import AddConciergeForm from './AddConciergeForm';
import {
  createNewConciergeData,
  getConciergeData,
  resetErrorAlert,
} from '../../../../slices/ConciergeSlice';

function ConciergeList() {
  const data = useSelector((state) => state.concierge.conciergeData);
  const isLoading = useSelector((state) => state.concierge.isLoading);
  const id = useSelector((state) => state.visits.selectedVisitId);
  const errorMessageCode = useSelector((state) => state.concierge.errorCode);
  const visit = useSelector((state) => state.visits);
  const isInternalVisit = useSelector((state) => state.visits.isInternalVisit);
  const isSubAdmin = useSelector((state) => state.login.isSubAdmin);
  const dispatch = useDispatch();

  const [showForm, setShowForm] = useState(false);
  const [selectedConciergeData, setSelectedConciergeData] = useState(null);

  // Fetch concierge data on mount
  useEffect(() => {
    dispatch(getConciergeData(id));
  }, [dispatch, id]);

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  function handleFormSubmit(newData) {
    if (newData) {
      const payload = { id: visit.selectedVisitId, newData };
      dispatch(createNewConciergeData(payload))
        .then(() => {
          dispatch(getConciergeData(id));
        });
    }
    setShowForm(false);
    setSelectedConciergeData(null);
  }

  if (isLoading) {
    return <Loader />;
  }

  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <div className="users-list-container">
      <div className="users-list-header-container">
        <div className="event-list-heading">
          {ConciergeStringLabels.concierge}
        </div>
        <button
          onClick={() => {
            setSelectedConciergeData(null);  // adding new concierge
            setShowForm(true);
          }}
          className={
            isSubAdmin || (data && data.length >= (isInternalVisit ? 4 : 2))
              ? 'button-style-disabled'
              : 'button-style'
          }
          disabled={isSubAdmin || (data && data.length >= (isInternalVisit ? 4 : 2))}
        >
          {ConciergeStringLabels.add}
        </button>
      </div>

      <AddConciergeForm
        show={showForm}
        onClickNext={handleFormSubmit}
        data={selectedConciergeData}  // null for adding new
        disableFields={selectedConciergeData === null && data && data.length >= 1}
      // disables fields only if adding and already have one or more concierge entries
      />

      <div className={`speakers-list-body${(!data || data.length === 0) ? ' empty' : ''}`}>
        {data && Array.isArray(data) && data.length > 0 ? (
          data.map((item, index) => (
            <ConciergeCard key={item.id || index} data={item} index={index} />
          ))
        ) : (
          <img
            src={noConcierge}
            alt="no AC Visit Partner"
            className="no-img"
          />
        )}
      </div>
    </div>
  );
}

export default ConciergeList;